
import { Job } from "@/util/interface";
import { state } from '@/util/job';
import { computed, defineComponent, PropType } from "vue";

export default defineComponent({
  name: "CardListing",
  props: {
    data: {
      type: Object as PropType<Job>,
      required: true,
    },
  },
  setup(props){
    const history = computed( () => {
     return state.convertTime(props.data.created_at)
    })
    return {
      history
    }
  }
});
